const relatedInsightItem = [
    {
        imageSrc: 'img/case-study/jpg/asset_prioritization.jpg',
        name: 'Asset Priortization',
        description: 'A mid-sized pharma client was working to develop their asset portfolio, and was interested to...',
        link: '/case-study/asset-prioritization'
    },
    {
        imageSrc: 'img/case-study/jpg/r_and_d_analysis.jpg',
        name: 'R&D Analysis',
        description: 'A mid-Pharma client based in India involved DelveInsight to assist in gathering and analyzing congress abstracts and literature review from various congresses for Parkinson’s disease.',
        link: '/case-study/r-and-d-analysis'
    },
    {
        imageSrc: 'img/case-study/jpg/competitive_benchmarking.jpg',
        name: 'Competitive Benchmarking',
        description: 'A large pharmaceutical client based in Europe involved DelveInsight to identify patient advocacy strategies of companies operating in the Pharma sector of the European Union, to benchmark their efforts against their competitors.',
        link: '/case-study/competitive-benchmarking'
    },
    {
        imageSrc: 'img/case-study/jpg/Oncology-Consulting-services-Tricky-question-of-Investing-or-divesting-in-an-asset.jpg',
        name: 'Market Assessment',
        description: 'A global pharmaceutical company wished to evaluate the market value of an asset obtained by acquiring a mid-cap company. ',
        link: '/case-study/immune-checkpoint-inhibitor-market-potential'
    },
]


const ConsultingData = {
    'asset-prioritizaton-services':{
        banner:{
            url: "img/banner/asset-prioritization-services.webp",
            title:'Asset Prioritization',
            description:
                <>
                    Develop an R&amp;D strategy with a reliable analysis of your asset group and come up focused list of prioritized assets.
                </>,
            service: 'Asset Prioritization Services'
        },
        introduction:{
            description:
            <>
                Any company’s bundle of assets is of vital importance to them. What needs to be assessed is how important they can become in a clinical setting, and how much these assets might lead to a sizeable return on investment to the company.
            </>,
            points:[
                {
                    pointsItems:'What plagues the healthcare setting at present, and might in the future, is the ever changing treatment regimens and the guidelines for using various therapies in different disease settings.'
                },
                {
                    pointsItems: 'Understanding the extent of life of an asset is a burning question that every R&D center working to develop pharmaceutical candidates aims to receive an answer to.'
                },
                {
                    pointsItems: 'Through asset prioritization analysis, a company can hope to make potential opportunities transparent and better understand their future performance to aid strategic decision-making on categorizing assets based on their potentiality.'
                }
            ]
        },
        perspective:{
            description:
            <>
                DelveInsight’s Asset Prioritization methodology employs intuitive assessments to initiate the client’s R&D journey. DelveInsight’s analysts work with the client team to develop intelligent criteria, create assessment scenarios through reliable parameters of importance and define situations for the consequence of possible successes and failures. Our Asset Prioritization service provides an understanding of future market dynamics through market modeling, unmet medical needs for future understanding of treatment regimens, and thus, helps create a sound strategy for the company’s research and development.
            </>,
            pointsHeading:'Our Business Development Service Indulges In:',
            perspectiveItems: [
                {
                    point: 'Sound Strategy for Prioritization of Assets'
                },
                {
                    point: 'Reliable Parameters of Focus'
                },
                {
                    point: 'Apply Treatment Guideline Knowledge to Define Futuristic outcome'
                },
                {
                    point: 'Prioritize Assets Based on Weight-based Parameter Assessment'
                },
                {
                    point: 'List the Probability of Asset Success'
                },
                {
                    point: 'Define Developmental Consequences'
                }
            ]
        }
    },
    'business-development-services':{
        banner:{
            title:'Business Development',
            url: "img/banner/business-development-services.webp",
            description:
                <>
                    Converting Strategic Plans into Intelligent Business Decisions
                </>,
            service: 'Business Development Services'
        },
        introduction:{
            description:
            <>
                Working through many innovative ideas, developing drugs and technologies, and
                creating value-based consumables for the Pharma/healthcare industry saps an extreme
                amount of investment from any company. Working towards developing a business for
                the same becomes an extreme choice for some. However, having a dedicated
                business-based approach is what segregates most of the companies from Big-Medium
                Pharmaceutical companies. Having a therapy/technology with the potential to
                become a blockbuster but not having enough business development activities can
                seriously harm the asset’s future potential.
            </>,
            points:[
                {
                    pointsItems:'Creating business value is a vital part of any asset’s journey. When that is compromised, it depletes the overall value of the asset.'
                },
                {
                    pointsItems: 'Considering business development, a core aspect, one needs to understand potential opportunities to provide a strategic direction for further development.'
                },
                {
                    pointsItems: 'The business development management process offers not only future development gains but also offers instant perks of creating a brand image of the asset and leveraging the company for future success.'
                }
            ]
        },
        perspective:{
            description:
            <>
                Business Development service offering from DelveInsight creates opportunity, provides strength and backing to the technology aspects of an organization, plots a definite growth trajectory and creates value for the client’s portfolio for future gains.
            </>,
            pointsHeading:'Our Business Development Service Indulges In:',
            perspectiveItems: [
                {
                    point: 'Implement cost-effective business processes'
                },
                {
                    point: 'Scouting for potential opportunities in the interest of the client’s portfolio'
                },
                {
                    point: 'Anticipate industry dynamics for flexible and resilient strategy generation'
                },
                {
                    point: 'Improve networking and client’s branding'
                },
                {
                    point: 'Define goals and objectives for short-term as well as long-term success'
                }
            ]
        }
    },
    'licensing-services':{
        banner:{
            title:'Licensing Services',
            url: "img/banner/licensing-services.webp",
            description:
                <>
                    Providing scientific innovation a boost toward clinical development and commercial milestone achievement
                </>,
            service: 'Licensing Services'
        },
        introduction:{
            description:
            <>
                Moving from a scientific to a business-oriented outlook is an inherent challenge of the Pharma market. This is why many blockbuster drugs of Big Pharma Players have been licensed from small Pharma players or academia centers of research universities, as the former entities have a great sense of business. Correctly called other’s science, these drugs receive a platform to perform exceptionally well in the market. Still, such licensing processes possess inherent challenges.
            </>,
            points:[
                {
                    pointsItems:'One challenge is faced by small Pharma players and academia who may unable to leverage their assets to an extent where Big Pharma can notice them.'
                },
                {
                    pointsItems: 'Conversely, Big Pharma Players fail to find a perfect asset that complements their R&D portfolio and strategic roadmap.'
                },
                {
                    pointsItems: 'Without outside help, these entities may lose the precious first-mover advantage, everything in the Pharma space.'
                }
            ]
        },
        perspective:{
            description:
            <>
                Here comes our game-modifying role, where we assist either of the entities to find the other through our proprietary licensing service offering. Designed in such a way that we see- every time- the best strategic licensing partner for our clients. (Having a specialty in all therapeutic areas and networks globally, we are expertly
                positioned to provide the best consulting advice.
            </>,
            pointsHeading:'Our Licensing Services Provide You:',
            perspectiveItems: [
                {
                    point: 'Ensured results with many potential companies for possible engagement'
                },
                {
                    point: 'Engagement service to set up meetings and initiate deal discussion'
                },
                {
                    point: 'A detailed list of companies with the probability of conducting licensing services'
                },
                {
                    point: 'Decision mapping matrix assessment with a list of top companies with the greatest level of strategic fit'
                }
            ]
        }
    },
    'merger-and-acquisition':{
        banner:{
            title:'Mergers and Acquisition',
            url: "img/banner/merger-and-acquisition.webp",
            description:
                <>
                    Providing scientific innovation a boost toward clinical development and commercial milestone achievement
                </>,
            service: 'Merger and Acquisition'
        },
        introduction:{
            description:
            <> Tackling a merger or an acquisition is a task on its own, and when port merger processes are put into the mix, another hotpot of challenges and barriers emerge. Having two entities with different outlooks, visions, strategies and capabilities and making them work on a shared philosophy requires foresight, forethought and a whole other level of expertise.    </>,
            points:[
                {
                    pointsItems:'Taking care of tangible assets is easier; however, managing post-merger integrations requires tacking managing the marriage of the entities’ intangible assets. Making sure the integration is a normal procedure makes integration a key challenge'
                },
                {
                    pointsItems: 'Another outlook to be assessed is the strategic rearranging of the post-merger organization to ensure the ultimate goal is easily achieved to complete a successful integration.'
                },
                {
                    pointsItems: 'Another major point is to keep the timing in mind, so that the changes do not take away the focus of the merger, which is to enhance shared capabilities for better positioning the merged entity in the market.'
                }
            ]
        },
        perspective:{
            description:
            <>
                DelveInsight’s services in their portfolio of consulting services provide expert opinion, unmatched experience, and cumulative insights of industry experts on navigating the complicated waters of post-merger or acquisition landscape. Not only do our in-house experts provide an understanding of how the entity’s future operating
                model would be, but they also manage processes by selecting priority processes, work
                to retain best practices, model the entity to be more agile and resilient, and focus on
                retaining talent by integrating and developing best resources for the entity.
            </>,
            pointsHeading:'Our Service Offering Provides:',
            perspectiveItems: [
                {
                    point: 'Seamless integration of capabilities, culture, and assets'
                },
                {
                    point: 'Demarcating responsibilities by department to manage tasks and goals'
                },
                {
                    point: 'Assess potential challenges for the entity in the market and provide actionable solutions for them'
                },
                {
                    point: 'Channelize strengths to improve strategy'
                },
                {
                    point: 'Aggressively channelize synergies for successful integration'
                },
                {
                    point: 'Provide open communication channels to streamline the process for smooth organizational functioning'
                }
            ]
        }
    },
    'partner-identification-services':{
        banner:{
            title:'Partner Identification',
            url: "img/banner/partner-identification-services.webp",
            description:
                <>
                    Service that helps identify, acquire, measure and manage collaborations
                </>,
            service: 'Partner Identification Services'
        },
        introduction:{
            description:
            <> Fostering long-term relationships among Pharmaceutical/Biotech companies provides an incentive to both partners, creating value for all the stakeholders involved. Here, companies might know what they want, but to go about the process is another ball game altogether.</>,
            points:[
                {
                    pointsItems:'Identifying, monitoring, and evaluating organizational barriers are vital for maintaining a strong foothold in the market'
                },
                {
                    pointsItems: 'Prioritizing interest provides an inherent challenge of finding another company of similar interests'
                },
                {
                    pointsItems: 'The different degrees of priority while conducting potential engagement might not produce the required results if the scouting is not done correctly'
                }
            ]
        },
        perspective:{
            description:
            <>
                DelveInsight’s partnering services provide opportunities to collaborate on a project where a company’s interest lies. Through extensive networks and detailed partnering methodology, our team is uniquely positioned to create a value-based relationship for our clients. The service platform scouts perfect candidates for partnership through a meticulous examination of unmet needs, validation of scientific and business perspectives and strategic fit.
            </>,
            pointsHeading:'Our Partnership Methodology Involves:',
            perspectiveItems: [
                {
                    point: 'Descriptive definition of the arena of interest to track intelligent leads'
                },
                {
                    point: 'Assessment of assets and technologies through defined landscaping parameters'
                },
                {
                    point: 'A transparent process updates for real-time understanding of the progress'
                },
                {
                    point: 'Test and re-test partnering hypothesis through in-house analysis tools'
                },
                {
                    point: 'Assigning different levels of interest to potential leads for stratified engagement'
                },
                {
                    point: 'Discernment of the other party’s interest in the partnership proposal'
                }
            ]
        }
    },
    'competitive-benchmarking-services':{
        banner:{
            title:'Competitive Benchmarking',
            url: "img/banner/competitive-benchmarking-services.webp",
            description:
                <>
                    Measure your brand among others in the competitive arena you occupy.
                </>,
            service: 'Competitive Benchmarking Services'
        },
        introduction:{
            description:
            <> Having no idea about the industry a company is a part of is almost like playing bulls-eye with a blindfold on. And competing in a sphere with limited knowledge of competitors and their strategies puts a company in a precarious position. Not every strategy of a company goes right and
                working in an environment of no external knowledge proves to be a gamble that may
                not pay very well. In hindsight, companies with valuable information relating to its
                competitors and the industry have been the most resilient and agile enough in terms of
                changes in strategy and flexible in introducing new processes and workflow.
                Competitive Benchmarking is a process that can help an organization assess changes
                in the industry, track competitors, and position itself to develop tactical maneuvers.</>,
            points:[
                {
                    pointsItems:'Assessing industry changes creates awareness of required modifications within the company and provides a platform to create newer and more innovative assets for better positioning in the future.'
                },
                {
                    pointsItems: 'Competitor Tracking and subsequent positioning provide an overarching understanding of inherent weaknesses and threats.'
                },
                {
                    pointsItems: 'Assessing best industry practices for incorporation'
                }
            ]
        },
        perspective:{
            description:
            <>
                Competitive benchmarking provides an understanding of what can and does not work
                and presents insights on what others are doing that can be adopted and which pitfalls
                other businesses had that can be avoided.
            </>,
            pointsHeading:'Competitive Benchmarking Provides Incentives To Clients In The Following Ways:',
            perspectiveItems: [
                {
                    point: 'Providing technical and business strategies that work in the market'
                },
                {
                    point: 'The business and the company culture can also be redefined through competitive benchmarking, which offers clients a chance to revamp their image, branding, initiatives, and internal processes using the analysis outcomes of DelveInsight.'
                },
                {
                    point: 'Implementing cost-effective business processes'
                },
                {
                    point: 'Uncovering competitor practices that might not receive many benefits'
                },
                {
                    point: 'Identifying strengths areas of the client for promotion'
                },
                {
                    point: 'Understanding new initiatives in the industry to improve on current working practices of the company'
                }
            ]
        }
    },
    'pharmaceutical-portfolio-management-solutions':{
        banner:{
            title:'Portfolio Management',
            url: "img/banner/pharmaceutical-portfolio-management-solutions.webp",
            description:
                <>
                    Matching Competencies and vision to develop a strong portfolio for future gains
                </>,
            service: 'Portfolio Management Services'
        },
        introduction:{
            description:
            <> Shrinking pipelines, lack of innovative ideas, increased cost of therapy development, regulatory pressures, reimbursement issues, and stagnation in revenue through previous innovative therapy sales are some of the major issues plaguing the Pharma sector and are also reasons that are forcing these companies to rethink their clinical developmental strategy to meet corporate goals.</>,
            points:[
                {
                    pointsItems:'There is an issue in not being able to understand which focus areas might or might not align with the company’s vision, depleting valuable resources that could otherwise be utilized on something beneficial in the future.'
                },
                {
                    pointsItems: 'A major aspect to be considered here is understanding one’s core competencies, assessing the assets and products that can be managed with those core competencies, and then understanding the bounds of one’s developmental and commercial aspects. '
                },
                {
                    pointsItems: 'Portfolio management includes assessment of products whose development might benefit the company’s future growth and aligns the company’s competencies with the company’s vision, creating a positive organizational culture and potent workforce.'
                }
            ]
        },
        perspective:{
            description:
            <>
                DelveInsight’s Portfolio Management services provide unmatched assistance in
                understanding your competencies, leveraging strengths to prioritize strategic goals, understanding the market’s current needs, and working on creating value for the
                customers and the company.
            </>,
            pointsHeading:'Our Portfolio Management Methodology Provides:',
            perspectiveItems: [
                {
                    point: 'Define the goals of the company to segregate priorities'
                },
                {
                    point: 'List probable avenues of organizational success'
                },
                {
                    point: 'Assess potential changes in the industry'
                },
                {
                    point: 'Understanding the needs of the end-user'
                },
                {
                    point: 'Channelize strengths to improve strategy'
                },
                {
                    point: 'Implement resource and cost saving processes'
                }
            ]
        }
    },
    'r-and-d-analysis':{
        banner:{
            title:'R&D Analysis',
            url: "img/banner/r-and-d-analysis.webp",
            description:
                <>
                    Understanding the realm of Pharmaceuticals to create value-based decisions and help clients achieve better outcomes in their R&D endeavors
                </>,
            service: 'R&D Services'
        },
        introduction:{
            description:
            <> R&amp;D efficiency is often calculated through the return on investments made on
                therapeutic candidates when they reach their commercialization stage and can earn
                revenue for the company that has developed it.</>,
            points:[
                {
                    pointsItems:'Such efficiency, however, has been declining in the Pharma R&amp;D sector, which propels decision-makers and CXOs to assess their portfolios&#39; relevancy in the early development stage.'
                },
                {
                    pointsItems: 'Assessing portfolio risk through assessment of candidate’s projected success and understanding ways of reducing cost of R&D are some ways which can help benchmark candidates of interest against the market parameters of success.'
                },
                {
                    pointsItems: 'Moreover, understanding competition at an early stage creates a foundation for assessing future market shares and deciding the candidate’s potential niche area in the market.'
                }
            ]
        },
        perspective:{
            description:
            <>
                The most basic way to understand the candidate’s journey through preclinical and
                clinical development is by assessing the exact parameters of other candidates already

                in the space. To help pharmaceutical companies evaluate the current scenario of a
                particular indication, Mechanism of Action, Active Pharmaceutical Ingredient, or a
                particular Drug candidate, etc. DelveInsight’s insight-packed reports clarify uncertainties
                and challenge blind spots to provide timely intelligence to the company.
            </>,
            pointsHeading:'Our R&D Analysis Service Provides:',
            perspectiveItems: [
                {
                    point: 'Comparative analysis'
                },
                {
                    point: 'A drug candidate’s overall developmental landscape'
                },
                {
                    point: 'In-depth insights on regulatory milestones'
                },
                {
                    point: 'Therapeutic assessment'
                },
                {
                    point: 'Details of asset-based collaborations and partnerships'
                },
                {
                    point: 'Developmental milestones of therapies of a particular indication, MoA, API, etc.'
                }
            ]
        }
    },
    'pipeline-assessment-services':{
        banner:{
            title:'Pipeline Assessment',
            url: "img/banner/pipeline-assessment-services.webp",
            description:
                <>
                    Have actionable intelligence to support your candidate through its clinical development journey.
                </>,
            service: 'Pipeline Assessment Services'
        },
        introduction:{
            description:
            <> Have actionable intelligence to support the development of your candidate through its
                clinical development journey. Understanding your therapy’s landscape allows you to
                better develop your prospect toward a blockbuster journey. It helps you differentiate
                yourself in a market with numerous candidates with average performance.</>,
            points:[
                {
                    pointsItems: 'The collective R&D portfolio of the biopharmaceutical world has been facing a great challenge of innovation depletion.'
                },
                {
                    pointsItems: 'Companies are now starting to think outside the box, work with newer classes of candidates, and explore newer mechanisms, targets, expression systems and developmental processes.'
                },
                {
                    pointsItems: 'This all, however, is possible only if they have a full idea of the landscape they are currently working in.'
                }
            ]
        },
        perspective:{
            description:
            <>
                DelveInsight’s Pipeline Assessment promises an overarching view of the arena you are interested in gaining more knowledge about, by working to provide every highlight of the landscape in a report format. Encompassing ready reports already present in our Report Store, our Pipeline Assessment report type provides insights across therapies, MoAs, Drugs, and APIs, as well as Launch Insights of drugs in the
                late stage of development to provide an understanding of their launch timelines and strategies.
            </>,
            pointsHeading:'Our Pipeline Assessment Provides You:',
            perspectiveItems: [
                {
                    point: 'Detailed profiling of candidates'
                },
                {
                    point: 'Reliable assessments of their developmental milestones'
                },
                {
                    point: 'Unmatched understanding of the therapies in the indication of your choice'
                },
                {
                    point: 'Key cross-analysis of candidates'
                },
                {
                    point: 'Comparative therapeutic assessment'
                },
                {
                    point: 'Understanding of their IP and regulatory history'
                }
            ]
        }
    },
    'market-assessment-services':{
        banner:{
            title:'Market Assessment',
            url: "img/banner/market-assessment-services.webp",
            description:
                <>
                    Achieve breakthroughs with all-encompassing market outlook research
                </>,
            service: 'Market Assessment Services'
        },
        introduction:{
            description:
            <> Achieve breakthroughs with all-encompassing market outlook researchThe healthcare market, out of any other market across industries, is prone to the most
            changes in short periods</>,
            points:[
                {
                    pointsItems: 'A drug with exceptional early stage developmental results may fail just before its expected market launch, whereas a therapy with minimal efficacy scores may find itself to be a blockbuster due to being the only therapy marketed for a particular indication.'
                },
                {
                    pointsItems: 'Such dynamicity in an industry creates large gaps in knowledge about own performance in the future, or in understanding competitor’s performance for the next decade.'
                },
                {
                    pointsItems: 'Deciding pivotal strategies, thus, becomes all the more challenging.'
                },
                {
                    pointsItems: 'Having a forecasted assessment for your therapy, and its competitors, provides a ray of foresight that is desperately needed at such times.'
                },
            ]
        },
        perspective:{
            description:
            <>
                Having a forecasted assessment for your therapy and its competitors provides a ray of foresight that is desperately needed at such times. DelveInsight’s Market Intelligence services become even more necessary. Our analysts have experience in business research and forecast assessment across pharmaceutical/biopharmaceutical industries to provide clients with the right projections of the future performance of key assets in a disease sphere. DelveInsight has been a part of many FTE and ad hoc projects, including insights from various research activities such as healthcare and therapy research, primary intelligence, data analysis, epidemiology modeling, and market forecast through data analysis techniques.
            </>,
            pointsHeading:'Our Market Assessment Involves:',
            perspectiveItems: [
                {
                    point: '10-year forecast'
                },
                {
                    point: 'Expertise in providing forecasts for emerging markets'
                },
                {
                    point: 'Inclusion of customization, as per client’s request, for additional geographies'
                },
                {
                    point: 'Key cross competition'
                },
                {
                    point: 'Drug uptake assessment and market size by therapies'
                },
                {
                    point: 'Detailed historical and forecasted market covering standard 7MM region'
                }
            ]
        }
    },
    'regulatory-analysis-services':{
        banner:{
            title:'Regulatory Analysis',
            url: "img/banner/regulatory-analysis-services.webp",
            description:
                <>
                    Understand the regulatory framework of different regulatory bodies across the globe,
                    and simplify the approval process
                </>,
            service: 'Regulatory Analysis Services'
        },
        introduction:{
            description:
            <> Different countries have different regulations and different regulations which means a lot of additional work for the same process.</>,
            points:[
                {
                    pointsItems: 'The approval process of NCE, biologics, biosimilars, cell or gene therapy, or even clinical trial products may become a labyrinth of guidelines, documents required, certifications needed, processes needed to be followed, trials needed to be conducted, etc.'
                },
                {
                    pointsItems: 'New guidelines, rules, and fee structures are coming up every other year, creating the dilemma only deeper.'
                },
                {
                    pointsItems: 'For a company that is unaware of a country’s regulatory process, sorting through the expansive data to make sense of the regulatory approval process becomes quite a challenge.'
                },
                {
                    pointsItems: 'Moreover, making a small mistake to return to square one is a risk no company is ready to take.'
                },
            ]
        },
        perspective:{
            description:
            <>
                Here comes the regulatory expertise of DelveInsight, where analysts have years of knowledge and extensive understanding of regulatory processes of almost every country of any region across the globe. We not only provide our clients with an understanding of the regulatory system of the countries they are interested in, but also help them sort out the similarities and differences among the different regulatory agencies, helping them map a pathway to regulatory approval across geographies.
            </>,
            pointsHeading:'Our Regulatory Analysis Encompasses Benefits Such As:',
            perspectiveItems: [
                {
                    point: 'Detailed understanding of the regulatory approval process'
                },
                {
                    point: 'Analysis of the geographies’ ease of regulatory approval to provide a priority list for commercialization'
                },
                {
                    point: 'Understanding client’s need for market access to provide actionable insights'
                },
                {
                    point: 'Ready-to-consume insights on the steps required for receiving approval'
                },
                {
                    point: "Customizable solutions, including finding local agents in regions where the native language might differ from the client’s language"
                },
                {
                    point: 'Detailed differentiation of regulatory approval pathways of different therapeutic entities'
                }
            ]
        }
    },
    'due-diligence-services':{
        banner:{
            title:'Due Diligence',
            url: "img/banner/due-diligence-services.png",
            description:
                <>
                    A comprehensive appraisal of assets and liabilities undertaken by DelveInsight to provide a bright outlook of an asset or a business or an entity.
                </>,
            service: 'Due Diligence Services'
        },
        introduction:{
            description:
            <> Misrepresentation is a very frequent problem Pharma industry has to go through while conducting M&A, Collaboration, or Partnership deals and while conducting C-level hiring. Not obtaining necessary information before time can cause mistakes in properly valuing deals, leading to problematic business operation in the future</>,
            points:[
                {
                    pointsItems: 'Identifying potential defects, pitfalls and snags of a deal become prudent when working on a timeline that is not forgiving can save potential hazards.'
                },
                {
                    pointsItems: 'While undertaking a decision, it is always prudent to understand all the opportunities and challenges of that decision.'
                },
                {
                    pointsItems: 'To outperform in today’s business scenario, working with proper foresight and confirmation is indispensable to avoid failure.'
                }
            ]
        },
        perspective:{
            description:
            <>
                Working through the quagmire of uncertainties is DelveInsight, whose team is well-equipped to gather intelligent data relating to a business, an entity or an individual, conduct activities that authenticate claims and provide insight on the suitability of the proposition. Through DelveInsight’s detailed analysis, our clients can be assured of the authenticity of a claim, correct representation of facts, and the possible ramifications of entering into a deal.
            </>,
            pointsHeading:'Our Due Diligence Service Helps By:',
            perspectiveItems: [
                {
                    point: 'Allowing a company to verify all pertinent information relating to a deal'
                },
                {
                    point: 'Providing aid for the strategic planning of the business process'
                },
                {
                    point: 'Offering Ready-to-consume insights on the steps required for receiving approval'
                },
                {
                    point: 'Ensuring assets and liabilities of the entity in question'
                },
                {
                    point: "Assiduously providing information regarding the current positioning of the entity"
                },
                {
                    point: 'Providing industrious skills in unravelling the finer details of any deal the client is interested in'
                }
            ]
        }
    },

    'ci-tracking':{

    },
    'primary-research-services':{
        
    },
    'conference-coverage-services':{
    },
    'competitive-intelligence-services':{
        banner:{
            title:'Asset Prioritization',
            description:
                <>
                    Develop R&amp;D strategy with reliable analysis of your asset group and come up focused list of prioritized assets.
                </>,
            service: 'Asset Prioritization Services'
        },
        introduction:{
            description:
            <>
                Any company’s bundle of assets are of vital importance to them. What needs to be assessed is how important they can become in a clinical setting, and how much these assets might lead to a sizeable return on investment to the company.
            </>,
            points:[
                {
                    pointsItems:'What plagues the healthcare setting at present, and might in the future, is the ever changing treatment regimens and the guidelines of using various therapies in different disease settings.'
                },
                {
                    pointsItems: 'Understanding the extent of life of an asset is a burning question that every R&D center working to develop pharmaceutical candidates aims to receive an answer to.'
                },
                {
                    pointsItems: 'Through asset prioritization analysis, a company can hope to make potential opportunities transparent and also aim to better understand the future performance of their assets, to aid strategic decision making on categorizing assets on the basis of their potentiality.'
                }
            ]
        },
        perspective:{
            description:
            <>
                DelveInsight’s Asset Prioritization methodology employs intuitive assessments to initiate the client’s R&D journey. DelveInsight’s analysts work with the client team to develop intelligent criteria, create assessment scenarios through reliable parameters of importance and define situations for consequence of possible successes and failures. Our Asset Prioritization service provides understanding future market dynamics through market modelling, unmet medical needs for future understanding of treatment regimens, and thus, help create a sound strategy for company’s research and development.
            </>,
            pointsHeading:'Our Business Development Service Indulges In:',
            perspectiveItems: [
                {
                    point: 'Sound Strategy for Prioritization of Assets'
                },
                {
                    point: 'Reliable Parameters of focus'
                },
                {
                    point: 'Apply Treatment Guideline knowledge to define Futuristic outcome'
                },
                {
                    point: 'Prioritize assets based on weight-based parameter assessment'
                },
                {
                    point: 'List probability of Asset Success'
                },
                {
                    point: 'Define Developmental Consequences'
                }
            ]
        }
    }
}

const consultingList = [
    {
        title: 'Competitive Intelligence',
        description: 'Identify plausible Market Opportunities and threats to exercise an optimized competitive strategy',
        buttonUrl: '/consulting/competitive-intelligence-services',
        imageSrc: '/img/consulting/jpg/competitive_intelligence_icon.jpg',
    },
    {
        title: 'Partner Identification',
        description: 'Access unique partner identification and collaboration services to facilitate business expansion',
        buttonUrl: '/consulting/partner-identification-services',
        imageSrc: '/img/consulting/jpg/partner_identification_icon.jpg',
    },
    {
        title: 'Licensing Services',
        description: 'Strategic consulting licensing services to ease drug development and commercialization milestones',
        buttonUrl: '/consulting/licensing-services',
        imageSrc: '/img/consulting/jpg/licensing_services_icon.jpg',
    },
    {
        title: 'Portfolio Management',
        description: 'Well-researched Market Knowledge for sound allocation of resources for maximum boost in the market',
        buttonUrl: '/consulting/pharmaceutical-portfolio-management-solutions',
        imageSrc: '/img/consulting/jpg/portfolio_management_icon.jpg',
    },
    {
        title: 'Asset Prioritization',
        description: 'Critical analysis prioritizing best possible asset for better return through development & commercialization',
        buttonUrl: '/consulting/asset-prioritization-services',
        imageSrc: '/img/consulting/jpg/asset_prioritization_icon.jpg',
    },
    {
        title: 'R&D Analysis',
        description: 'Tailor-made research services providing optimized strategies for a strong foothold in the Pharma market',
        buttonUrl: '/consulting/r-and-d-analysis',
        imageSrc: '/img/consulting/jpg/r_&_d_analysis_icon.jpg',
    },
    {
        title: 'Merger and Acquisition',
        description: 'Seamless integration of merged entities to leverage best business profile for increased performance',
        buttonUrl: '/consulting/merger-and-acquisition',
        imageSrc: '/img/consulting/jpg/merger_&_acquisition_icon.jpg',
    },
    {
        title: 'Competitive Benchmarking',
        description: 'Competitively place oneself via analysis of information about industry players and their potential moves',
        buttonUrl: '/consulting/competitive-benchmarking-services',
        imageSrc: '/img/consulting/jpg/competitive_benchmarking_icon.jpg',
    },
    {
        title: 'Business Development',
        description: 'Valuable business insights to help growth of the company in the dynamic Pharma market',
        buttonUrl: '/consulting/business-development-services',
        imageSrc: '/img/consulting/jpg/business_development_icon.jpg',
    },
    {
        title: 'Pipeline Assessment',
        description: 'In-depth assessment of assets and therapies across the pipeline of clinical development',
        buttonUrl: '/consulting/pipeline-assessment-services',
        imageSrc: '/img/consulting/jpg/pipeline_assessment_icon.jpg',
    },
    {
        title: 'Market Assessment',
        description: 'Elucidated analysis for a critical and comprehensive understanding of indication-based market trends',
        buttonUrl: '/consulting/market-assessment-services',
        imageSrc: '/img/consulting/jpg/market_assessment_icon.jpg',
    },
    {
        title: 'Regulatory Analysis',
        description: 'Systematic analysis to understand minute requirements of prevailing regulations across geographies',
        buttonUrl: '/consulting/regulatory-analysis-services',
        imageSrc: '/img/consulting/jpg/regulatory_analysis_icon.jpg',
    },
    {
        title: 'Primary Research',
        description: 'Holistic consulting services in life sciences, encompassing market research and analytical solutions.',
        buttonUrl: '/consulting/primary-research-services',
        imageSrc: '/img/consulting/jpg/primary-services.png',
    },
    {
        title: 'CI Tracking',
        description: 'Our CI Tracking provides real-time competitive intelligence, enhancing strategic decision-making.',
        buttonUrl: '/consulting/ci-tracking',
        imageSrc: '/img/consulting/jpg/ci-tracking.png',
    },
    {
        title: 'Conference Coverage',
        description: 'Comprehensive offering that provides clients with coverage of healthcare conferences and events.',
        buttonUrl: '/consulting/conference-coverage-services',
        imageSrc: '/img/consulting/jpg/conference-coverage.png',
    },
]


export {
    ConsultingData,
    relatedInsightItem,
    consultingList
}